import { render } from "./nft-marketplace.vue?vue&type=template&id=62f16229&scoped=true"
import script from "./nft-marketplace.vue?vue&type=script&lang=js"
export * from "./nft-marketplace.vue?vue&type=script&lang=js"

import "./nft-marketplace.vue?vue&type=style&index=0&id=62f16229&scoped=true&lang=css"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f16229"]])

export default __exports__